export enum NotificationType {
  NONE = 0,
  INFO = 1,
  ERROR = 2,
  CONFIRM = 3,
}
